jQuery(document).ready(function ($) {
    if (modules_object["maps"]) {
        const pathname = location.protocol + '//' + location.host + '/wp-content/themes/casinospezialist.com-child/assets/images/modules/map-icon.webp';
        const locations = modules_object["maps"][0];
        let markers = [];
        let newMarker;
        let cityContainer = $('.region__container__city');
        let body = $('.region__container__city__body');
        let search = $('.region__search--input');
        let cityName = '.region__container__city__title--name';
        let casinoName = '.region__container__city__body__info--name';

        //Toggle for city when clicking plus or minus button
        for (let index = 0; index < cityContainer.length; index++) {
            let plusIcon = ".plus-icon-" + index;
            let minusIcon = ".minus-icon-" + index;
            $(minusIcon).css('display', 'none');

            if (index === 0) {
                $('.plus-icon-0').css('display', 'none');
                $('.minus-icon-0').css('display', 'block');
                cityContainer.first().addClass('active');
            }

            $(plusIcon).on('click', function (e) {
                $(this).css('display', 'none');
                $(minusIcon).css('display', 'block');
                $(this).parent().parent().parent().addClass('active');
            });

            $(minusIcon).on('click', function (e) {
                $(this).css('display', 'none');
                $(plusIcon).css('display', 'block');
                $(this).parent().parent().parent().removeClass('active');
            });
        }

        //Initialize Map
        initializeMap();

        function initializeMap() {
            let map = new google.maps.Map(document.getElementById('map'), {
                zoom: 5,
                center: new google.maps.LatLng(52, 9),
                mapTypeId: google.maps.MapTypeId.ROADMAP
            });
            let infowindow = new google.maps.InfoWindow();
            let service = new google.maps.places.PlacesService(map);
            let allMarkers = [];
            let result = [];

            for (let bodyIndex = 0; bodyIndex < $(body).length; bodyIndex++) {
                const request = {
                    query: $(body[bodyIndex]).find('.region__container__city__body__info--name').text(),
                    fields: ["name", 'rating', "user_ratings_total"],
                };
                service.findPlaceFromQuery(request, (results, status) => {
                    if (status === google.maps.places.PlacesServiceStatus.OK && results) {
                        result.push(results[0]);
                        let rating = (results[0].rating * 20) + "%";
                        $(body[bodyIndex]).find('.region__container__city__body__info__wrapper--rating').text(results[0].rating);
                        $(body[bodyIndex]).find('.region__container__city__body__info__wrapper--text').text('(' + (results[0].user_ratings_total) + ')');
                        $(body[bodyIndex]).find('.rating__star-on').css('width', rating);
                    }
                });
            }


            for (const location of Object.entries(locations)) {
                let city = location[1];
                let casinos = city.casinos;
                let icon = {
                    url: pathname,
                    scaledSize: new google.maps.Size(30, 30)
                };

                for (let i = 0; i < casinos.length; i++) {
                    newMarker = new google.maps.Marker({
                        position: new google.maps.LatLng(parseFloat(casinos[i].latitude), parseFloat(casinos[i].longitude)),
                        map: map,
                        title: city.name,
                        icon: icon,
                        casino: casinos[i].name
                    });

                    allMarkers.push(newMarker);

                    $(search).keyup(function () {
                        let filter = $(this).val();
                        let plusIcon = ".plus-icon-" + i;
                        let minusIcon = ".minus-icon-" + i;
                        //Show search results aside
                        $(cityContainer).each(function () {
                            if ($(this).find(cityName).text().search(new RegExp(filter, "i")) > -1 || $(this).find(casinoName).text().search(new RegExp(filter, "i")) > -1) {
                                $(this).css('display', '');
                                $(minusIcon).css('display', 'block');
                                $(plusIcon).css('display', 'none');
                            } else {
                                $(this).css('display', 'none');
                            }
                        });
                        $(body).each(function () {
                            if ($(this).find(casinoName).text().search(new RegExp(filter, "i")) > -1 || $(this).parent().find(cityName).text().search(new RegExp(filter, "i")) > -1) {
                                $(this).css('display', 'grid');
                                $(minusIcon).on('click', function (e) {
                                    $(this).css('display', 'none');
                                    $(plusIcon).css('display', 'block');
                                    $(this).parent().parent().parent().find('.region__container__city__body').css('display', 'none');
                                });
                                $(plusIcon).on('click', function (e) {
                                    $(this).css('display', 'none');
                                    $(minusIcon).css('display', 'block');
                                    $(this).parent().parent().parent().find('.region__container__city__body').css('display', 'grid');
                                });
                            } else {
                                $(this).css('display', 'none');
                            }
                        });
                        //reset after search

                        if (filter === '') {
                            $(minusIcon).css('display', 'none');
                            $(plusIcon).css('display', 'block');
                            $(body).css('display', 'none');
                            cityContainer.removeClass('active');
                        }
                        //Show search results on map

                        for (const [key, marker] of Object.entries(allMarkers)) {
                            if (marker.title.search(new RegExp(filter, "i")) > -1 || marker.casino.search(new RegExp(filter, "i")) > -1) {
                                allMarkers[key].setVisible(true);
                            } else {
                                allMarkers[key].setVisible(false);
                            }
                        }
                    });

                    google.maps.event.addListener(newMarker, 'click', function (newMarker) {
                        return function () {
                            let infoBodyStart = "<div style='display: grid; grid-template-columns: 1fr 8.2rem; grid-gap: .8rem'>";
                            let infoContentStart = "<div class='region__container__city__body__info'>";
                            let infoCasinoName = "<a class=region__container__city__body__info--name' href='" + casinos[i].review_link + "'>" + casinos[i].name + "</a>";
                            let starsWrapper = "<div class='region__container__city__body__info__wrapper'>";
                            let starsRating = "<span class='region__container__city__body__info__wrapper--rating'>" + result[i].rating + "</span>";
                            let stars = "<div class='region__container__city__body__info__wrapper--stars'>" + casinos[i].rating + "</div>";
                            let starsReview = "<span class='region__container__city__body__info__wrapper--text'>(" + result[i].user_ratings_total + ")</span>";
                            let infoCasinoRating = starsWrapper + starsRating + stars + starsReview + "</div>";
                            let infoContentEnd = "</div>";
                            let infoCasinoLogo = "<a class='infoWindow__casino-logo' href='" + casinos[i].review_link + "'><img class='region__container__city__body--logo' alt='google' " +
                                "title='" + casinos[i].name +"' src='" + casinos[i].thumbnail + "'></a>";
                            let infoBodyEnd = "</div>";
                            let content = infoBodyStart + infoContentStart + infoCasinoName + infoCasinoRating + infoContentEnd + infoCasinoLogo + infoBodyEnd;
                            infowindow.setContent(content);
                            infowindow.open(map, newMarker);
                        };
                    }(newMarker, city));
                    markers.push(newMarker);
                }
            }
        }

        $('.region__search--clear').on('click', function () {
            $(search).val('');
        });
    }
});